// A plain JSON object, for parsers re-checking stored payloads before reading their keys.
const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export default isRecord;
